import React from "react";
import Link from "next/link";
import { resizeImage } from "@lib/helpers";

const ProductBrand = ({ product }) => {
  const { brand_link, brand_logo, brand_name } = product;

  const isAppleBrand = brand_name.toLowerCase() === "apple";
  const link = isAppleBrand ? "/shop/apple" : brand_link;

  return (
    <div className="mx-auto max-w-lg">
      <Link href={link}>
        <a>
          <div className="border-[#D9D9D9] border rounded-md p-4 flex flex-col xs:flex-row items-center justify-between text-14px gap-1">
            <img
              src={resizeImage(brand_logo, "300x300")}
              alt={brand_name}
              className="h-10 w-auto"
            />
            <div>Vezi toate produsele</div>
          </div>
        </a>
      </Link>
    </div>
  );
};

export default ProductBrand;
